import { TAnalyticsMessagePayload } from '../../types';
import { normalizePage } from './utils';
import { trackPageview } from './analytics';

export function pageviewSiteHandler([, eventParams]: TAnalyticsMessagePayload) {
  trackPageview(normalizePage(eventParams));
}
